export default __webpack_public_path__ + "static/media/utjd_logo.fd459207.jpg";